import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Main } from '../../components';
import { setDepositData } from '../../store/features/deposit/deposit.slice';
import { onCalculateDeposit } from '../../utils/business';
import CredentialsForm from './components/CredentialsForm/CredentialsForm';
import DepositCalculationData from './components/DepositCalculationData/DepositCalculationData';
import InterestsSchedule from './components/InterestsSchedule/InterestsSchedule';
import { DepositCredentials } from './utils';
import langFile from '../../data/lang.json';
import { useTypedSelector } from '../../store/hooks';

const Deposits: React.FC = () => {
    const dispatch = useDispatch();
    const { lang } = useTypedSelector((state) => state.common);
    const { amount, percent, period, daysInMonth, daysInYear, interests } = useTypedSelector(
        (state) => state.deposit,
    );
    const [capitalize, setCapitalize] = useState<boolean>(false);

    const handleSubmit = (data: DepositCredentials) => {
        const results = onCalculateDeposit(
            Number(data.amount),
            Number(data.percent),
            Number(data.period),
            Number(data.daysInMonth),
            Number(data.daysInYear),
            capitalize,
        );

        dispatch(
            setDepositData({
                ...data,
                ...results,
            }),
        );
    };

    return (
        <Main active={1}>
            <CredentialsForm
                results={
                    <>
                        <DepositCalculationData />
                        <FormGroup sx={{ pl: 2 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={capitalize}
                                        onChange={(e) => {
                                            setCapitalize(e.target.checked);

                                            if (interests.length > 0) {
                                                const results = onCalculateDeposit(
                                                    amount,
                                                    percent,
                                                    period,
                                                    daysInMonth,
                                                    daysInYear,
                                                    e.target.checked,
                                                );

                                                dispatch(
                                                    setDepositData({
                                                        amount,
                                                        percent,
                                                        period,
                                                        daysInMonth,
                                                        daysInYear,
                                                        ...results,
                                                    }),
                                                );
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Typography variant="body2">
                                        {(langFile.withCapitalize as any)[lang]}
                                    </Typography>
                                }
                            />
                        </FormGroup>
                    </>
                }
                onSubmit={handleSubmit}
            />
            <InterestsSchedule />
        </Main>
    );
};

export default Deposits;
